import { useSocialExportGetRudoFolders } from '@mi-front/api-v2';
import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { RudoCreateFolderControl } from './RudoCreateFolderControl';
import { RudoFoldersAutocomplete } from './RudoFoldersAutocomplete';

type Props = {
  connectionId: string;
  /** When true, folder selection is required (publish form). */
  required?: boolean;
};

/**
 * Folder picker for Rudo settings/publish: searchable autocomplete + create folder.
 */
export function RudoFoldersField({ connectionId, required = false }: Props) {
  const foldersQuery = useSocialExportGetRudoFolders(connectionId, {
    query: { enabled: !!connectionId },
  });

  const folders = useMemo(() => {
    const data = foldersQuery.data?.data ?? [];
    return [...data].sort((a, b) => a.name.localeCompare(b.name));
  }, [foldersQuery.data?.data]);

  return (
    <Stack spacing={1} alignItems="flex-start" sx={{ width: '100%' }}>
      <RudoFoldersAutocomplete
        folders={folders}
        isLoading={foldersQuery.isLoading}
        required={required}
      />
      <RudoCreateFolderControl connectionId={connectionId} />
    </Stack>
  );
}
